<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>充放管理</el-breadcrumb-item>
          <el-breadcrumb-item>订单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box" :style="heightToolsBar">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                type="primary"
                icon="el-icon-document-checked"
                @click="fileExport()"
                >导出</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-document-checked"
                @click="fillDialogOpen()"
                >补传</el-button
              >
            </el-button-group>
          </div>
          <div class="r-list">
            <div class="option">
              <cn-select-search
                v-model="companyId"
                :v_disabled="disabled"
                :v_whole="true"
                :data="companyList"
                @val="setCompanyId"
                placeholder="请筛选客户..."
              >
              </cn-select-search>

              <el-select
                v-model="cabinetId"
                placeholder="请选择设备..."
                class="sb_select"
              >
                <el-option :key="0" label="全部设备" :value="0"></el-option>
                <el-option
                  v-for="item in cabinetList"
                  :key="item.id"
                  :label="`${item.cabinetCode}  /  ${item.cabinetName}`"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="chargeType"
                placeholder="请选择状态..."
                class="zt_select"
              >
                <el-option label="全部状态" :value="-1"></el-option>
                <el-option label="空闲" :value="0"></el-option>
                <el-option label="充电" :value="1"></el-option>
                <el-option label="放电" :value="2"></el-option>
              </el-select>
              <el-date-picker
                style="width: 280px"
                v-model="dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
            <div class="search-box">
              <el-input
                placeholder="输入关健字"
                v-show="false"
                v-model="keyword"
                @keyup.enter.native="initData"
              >
              </el-input>
              <el-button
                type="primary"
                slot="append"
                icon="el-icon-search"
                @click="initData"
                style="float: right"
              ></el-button>
            </div>
            <div class="btn-box" v-show="false">
              <el-button-group>
                <el-button
                  type="primary"
                  :icon="iconToolsBar"
                  @click="toggleToolsBar"
                ></el-button>
              </el-button-group>
            </div>
          </div>
        </div>

        <div class="more-box">
          <dl>
            <dt>筛选设备</dt>
            <dd></dd>
          </dl>
          <dl>
            <dt>充放状态</dt>
            <dd></dd>
          </dl>

          <dl>
            <dt>上报时间</dt>
            <dd></dd>
          </dl>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称" min-width="80">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyName }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column
              prop="cabinetCode"
              label="设备编号"
            ></el-table-column>
            <el-table-column
              prop="cabinetName"
              label="设备标签"
              min-width="100"
            ></el-table-column>
            <el-table-column label="状态" min-width="50" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.chargeType == 1">充电</span>
                <span v-else-if="scope.row.chargeType == 2">放电</span>
                <span v-else>空闲</span>
              </template>
            </el-table-column>
            <el-table-column label="时段" min-width="50" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.periodType == 1">尖</span>
                <span v-else-if="scope.row.periodType == 2">峰</span>
                <span v-else-if="scope.row.periodType == 3">平</span>
                <span v-else-if="scope.row.periodType == 4">谷</span>
                <span v-else>高尖</span>
              </template>
            </el-table-column>

            <el-table-column label="充电量(度)" min-width="90">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.chargePower }}</span>
              </template>
            </el-table-column>

            <el-table-column label="放电量(度)" min-width="90">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.dischargePower }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="profit"
              label="收益(元)"
              min-width="80"
              v-if="isShow"
            ></el-table-column>

            <el-table-column label="开始时间" width="82">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.startTime }}</span>
              </template>
            </el-table-column>

            <el-table-column label="结束时间" width="82">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="上报时间" width="82">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.gmtCreate }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="130">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-view"
                  v-if="flagLook"
                  @click="linkUrl(scope.row.id)"
                ></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  v-if="flagDel"
                  @click="deleteItem(scope.row.id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>

      <el-dialog title="" :visible.sync="showFillDialog" fullscreen>
        <div class="content-box side">
          <el-card shadow="hover">
            <div slot="header" class="clearfix">
              <i class="iconfont icon-setting-full"></i>
              <span>账单补传</span>
            </div>
            <el-form label-width="100px">
              <el-form-item label="上传说明">
                <b style="color: red"
                  >补传的文件必需是csv文件，并且文件名包含指定日期。</b
                >
              </el-form-item>
              <el-form-item label="选择设备">
                <cn-select-search
                  v-model="companyId"
                  :v_disabled="disabled"
                  :v_whole="false"
                  :data="companyList"
                  @val="setCompanyId"
                  placeholder="请筛选客户..."
                >
                </cn-select-search>

                <el-select
                  v-model="cabinetId"
                  placeholder="请选择设备..."
                  class="sb_select"
                >
                  <el-option :key="0" label="全部设备" :value="0"></el-option>
                  <el-option
                    v-for="item in cabinetList"
                    :key="item.id"
                    :label="item.cabinetName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="补传数据">
                <el-upload
                  :limit="1"
                  ref="upload"
                  action=""
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  :multiple="true"
                  :auto-upload="false"
                  style="width: 300px"
                >
                  <el-button slot="trigger" style="width: 120px" type=""
                    >选取文件</el-button
                  >
                  <el-button
                    icon="el-icon-document-checked"
                    type="primary"
                    @click="submitUpload"
                    >上传</el-button
                  >
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      isShow: false,
      uploadUrl: "", //上传地址
      fileList: [], //上传
      showFillDialog: false, //补传窗口
      disabled: false,
      companyId: "",
      cabinetId: "",
      //fillCompanyId: "",//补录
      //fillCabinetId: "",//补录
      chargeType: "",
      companyList: [],
      cabinetList: [],
      showToolsBar: false, //显示更多条件选项
      heightToolsBar: "min-height:60px", //工具栏高度
      iconToolsBar: "iconfont icon-d-arrow-down", //更多按钮图标
      loading: false,
      orderType: -1,
      keyword: "",
      dateRange: [],
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      flagAdd: false,
      flagDel: false,
      flagUpdate: false,
      flagLook: false,
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "结算中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "充放订单");
        if (obj1.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj1.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj1.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj1.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }
        obj1.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
        });
      }
    },
    //初始化工具栏
    initLoad: function () {
      let _this = this;

      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.disabled = true;
        _this.companyId = window.localStorage.getItem("fx_login_companyId");
        _this.getCabinetList(_this.companyId);
      } else {
        _this.isShow = true;
      }
    },
    getCabinetList: function (companyId) {
      let _this = this; //当前页面
      _this.cabinetList = [];
      //加载设备列表
      AxiosAjax({
        url: "/cabinet/cabinet/page?index=1&size=9000&companyId=" + companyId,
        loading: true,
        success: function (res) {
          _this.cabinetList = res.data.data.content;
          if (_this.$route.params.companyId) {
            _this.cabinetId = _this.$route.params.cabinetId;
          }
        },
      });
    },
    //显示补传窗口
    fillDialogOpen: function () {
      let _this = this;
      _this.companyId = "";
      _this.cabinetId = "";
      _this.showFillDialog = true;
    },
    submitUpload() {
      let _this = this;

      if (_this.cabinetId == "") {
        _this.$message({
          type: "warning",
          message: "未选择设备...",
        });

        return;
      }

      if (_this.$refs.upload.uploadFiles.length == 0) {
        _this.$message({
          type: "warning",
          message: "未选择文件...",
        });

        return;
      }

      const formData = new FormData();

      _this.$refs.upload.uploadFiles.forEach((file) => {
        formData.append("file", file.raw);
      });

      formData.append("cabinetId", _this.cabinetId);

      //下发费率
      AxiosAjax({
        method: "file",
        url: "/cabinet/upload/uploadBillAndStats",
        data: formData,
        loading: true,
        success: function (res) {
          if (res.data.code == "000000") {
            console.log(res.data.msg);
            _this.$message({
              type: "warning",
              message: "上传成功...",
            });
          }
        },
      });

      //this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    fileExport() {
      //下载

      let _this = this;

      let sendUrl = "/cabinet/order/export";

      sendUrl += "?index=1";
      sendUrl += "&size=9999999";

      if (_this.companyId.length > 0 && _this.companyId != 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      if (_this.cabinetId.length > 0 && _this.cabinetId != 0) {
        sendUrl += "&cabinetId=" + _this.cabinetId;
      }

      if (_this.chargeType.toString().length > 0 && _this.chargeType > -1) {
        sendUrl += "&chargeType=" + _this.chargeType;
      }

      if (_this.dateRange.length > 0) {
        sendUrl += "&startTimeFrom=" + _this.dateRange[0] + " 00:00:00";
        sendUrl += "&startTimeTo=" + _this.dateRange[1] + " 23:59:59";
      }

      AxiosAjax({
        method: "down",
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          const contentType = res.headers["content-type"];
          let blob = new Blob([res.data], { type: contentType }); //生成blob文件
          const url = URL.createObjectURL(blob); //生成URL
          let a = document.createElement("a");
          a.href = url;
          a.download = "充放" + new Date().pattern("yyyyMMddHHmmss") + ".xlsx";
          a.click();
          a.remove();
          URL.revokeObjectURL(a.href);
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/order/page";

      sendUrl += "?index=" + _this.pageIndex;
      sendUrl += "&size=" + _this.pageSize;

      if (_this.companyId.length > 0 && _this.companyId != 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      if (_this.cabinetId.length > 0 && _this.cabinetId != 0) {
        sendUrl += "&cabinetId=" + _this.cabinetId;
      }

      if (_this.chargeType.toString().length > 0 && _this.chargeType > -1) {
        sendUrl += "&chargeType=" + _this.chargeType;
      }

      if (_this.dateRange.length > 0) {
        sendUrl += "&startTimeFrom=" + _this.dateRange[0] + " 00:00:00";
        sendUrl += "&startTimeTo=" + _this.dateRange[1] + " 23:59:59";
      }

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //跳转链接
    linkUrl: function (url) {
      this.$router.push({ name: "OrderShow", query: { id: url } });
    },
    //切换更多查询条件
    toggleToolsBar: function () {
      this.showToolsBar = !this.showToolsBar;
      if (this.showToolsBar) {
        this.heightToolsBar = "height:auto";
        this.iconToolsBar = "iconfont icon-d-arrow-up";
      } else {
        this.heightToolsBar = "height:60px";
        this.iconToolsBar = "iconfont icon-d-arrow-down";
      }
    },
    //单项删除
    deleteItem: function (val) {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //执行删除操作
      _parent
        .$confirm("确认要删除该记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "delete",
            url: "/cabinet/order/" + val,
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              _this.initData(); //重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
      this.cabinetId = 0;
      this.getCabinetList(this.companyId);
    },
  },
  created: function () {
    //初始化工具栏
    this.initLoad();
    if (this.$route.params.companyId) {
      this.companyId = this.$route.params.companyFullName;
      this.setCompanyId(this.$route.params.companyId);
      this.cabinetId = this.$route.params.cabinetId;
    }

    //加载数据
    this.initData();
  },
};
</script>
<style scoped>
.content-box .table-list .nowrap {
  white-space: inherit;
}
.sb_select > .el-input {
  width: 130px;
}
.zt_select > .el-input {
  width: 130px;
}
</style>




// WEBPACK FOOTER //
// src/components/Order/OrderList.vue